import { MUT_ALTERS } from "./mut-columns.js";

// NOTE: `last_push_at` no longer exists on fresh installs — outbound Google
// dirtiness is the per-row `mut > google_acked_mut` fact. Old installs keep the
// column (SQLite can't drop it); `backfillMutColumns` reads it once to map each
// row's Google cleanliness, after which it is dead.
export const calendarsTable = `
CREATE TABLE IF NOT EXISTS calendars (
  id          TEXT PRIMARY KEY,
  name        TEXT NOT NULL,
  color       TEXT,
  hidden      INTEGER NOT NULL DEFAULT 0,
  owner_id    TEXT,
  external_calendar_id TEXT,
  external_source      TEXT,
  external_account     TEXT,
  sync_direction       TEXT NOT NULL DEFAULT 'off',
  sync_token           TEXT,
  last_synced_at       TEXT,
  mut                  INTEGER NOT NULL DEFAULT 0,
  server_acked_mut     INTEGER NOT NULL DEFAULT 0,
  google_acked_mut     INTEGER NOT NULL DEFAULT 0,
  created_at  TEXT NOT NULL,
  updated_at  TEXT NOT NULL,
  deleted_at  TEXT
);
`.trim();

/** ALTER statements to bring an existing `calendars` table up to the current
 *  schema. Each is wrapped in try/catch by migrate() (re-applying ADD COLUMN on
 *  an existing column errors). Mirrors `tasksAlters`. */
export const calendarsAlters = [
  "ALTER TABLE calendars ADD COLUMN external_calendar_id TEXT;",
  "ALTER TABLE calendars ADD COLUMN external_source TEXT;",
  "ALTER TABLE calendars ADD COLUMN external_account TEXT;",
  "ALTER TABLE calendars ADD COLUMN sync_direction TEXT NOT NULL DEFAULT 'off';",
  "ALTER TABLE calendars ADD COLUMN sync_token TEXT;",
  "ALTER TABLE calendars ADD COLUMN last_synced_at TEXT;",
  ...MUT_ALTERS("calendars"),
];
